import { Meter } from '#~/audio/components/meter/index.js';
import { Offset } from '#~/audio/components/offset/index.js';
import { Content as _Content, Columns } from '#~/common/editor/index.js';
import { useProducer, useStore } from './store/hooks.js';
//import { useWiring } from './wiring.js';
//import { Button } from '@studio/design-system/button';
import { Column, Group } from '@studio/design-system/form';
import { Mediator } from '@studio/design-system/input';
import type { HtmlAttributes } from '@studio/design-system/props';
import { AudioDefaults } from '@studio/models/audio';
import { toAccessor } from '@studio/react-utils';
import { useLatestFn } from '@studio/react-utils/hooks';
import { toString } from '@tryiris-ai/js-types';
import type { ReactElement, SyntheticEvent } from 'react';
import { shallow } from 'zustand/shallow';

/** Settings `<Content>` component. */
export const Content = (props: HtmlAttributes): ReactElement => {
  const producer = useProducer();
  //const wiring = useWiring();

  const store = useStore(
    ({ candidate }) => ({
      deviceId: candidate.id,
      hasVideo: !!candidate.video,
      name: candidate.name,
      offset: candidate.audio?.offset ?? AudioDefaults.offset
    }),
    shallow
  );

  const handleNameChange = useLatestFn((nextValue: string, event: SyntheticEvent) => {
    const nextName = toString(nextValue);

    if (nextName && nextName !== store.name) {
      producer((draft) => {
        draft.candidate.name = nextName;
      });
    } else {
      event.preventDefault();
    }
  });

  const handleOffsetChange = useLatestFn((nextOffset: number) => {
    if (nextOffset !== store.offset) {
      producer((draft) => {
        const { audio } = draft.candidate;

        draft.candidate.audio = { ...audio, offset: nextOffset };
      });
    }
  });

  return (
    <_Content {...props}>
      <Columns>
        <Columns.Column>
          <h3>Source settings</h3>

          <Column>
            <Group label='Audio source'>
              <Mediator disabled={store.hasVideo} onCommit={handleNameChange} value={store.name} />
            </Group>

            <Offset offset={toAccessor(store.offset, handleOffsetChange)} />
            {/*<div style={{ display: 'flex' }}>
              <div style={{ marginRight: '10px' }}>
                <Button onClick={wiring.handleStartEgress}>
                  Start Ndi Egress
                </Button>
              </div>
              <div>
                <Button onClick={wiring.handleStopEgress}>
                  Stop Ndi EgreAuss
                </Button>
              </div>
             </div>*/}
          </Column>
        </Columns.Column>

        <div>
          <h3>Preview</h3>
          <Meter deviceId={store.deviceId} />
        </div>
      </Columns>
    </_Content>
  );
};
